// extracted by mini-css-extract-plugin
export default {"result":"ResultMessage_result__jy+z1"};